import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'
import config from '../config'

Vue.use(Vuex)

const initialState = {
  administratorFilter: '',
  reportedCommunities: []
}

const getters = {
  administratorFilter: state => state.administratorFilter,
  reportedCommunities: state => state.reportedCommunities
}

const mutations = {
  setAdministratorFilter: (state, administratorFilter) => {
    state.administratorFilter = administratorFilter
  },
  setReportedCommunities: (state, reportedCommunities) => {
    state.reportedCommunities = reportedCommunities
  },
  softDelete: (state, communityId) => {
    const index = state.reportedCommunities.findIndex(community => community.id === communityId)
    state.reportedCommunities.splice(index, 1)
  }
}

const actions = {
  filterAdministrator ({ commit }, filter) {
    commit('setAdministratorFilter', filter)
  },
  async unreportCommunity ({ commit }, communityId) {
    return axios.post(`${config.getRootApi()}/admin/communities/${communityId}/unreport`)
      .then(response => {
        if (response.status === 200) {
          commit('softDelete', communityId)
          commit('decrementCountReportedContent')
          return true
        } else {
          return false
        }
      }).catch(() => {
        return false
      })
  },
  async deleteCommunity ({ commit }, communityId) {
    return axios.delete(`${config.getRootApi()}/admin/communities/${communityId}`)
      .then(response => {
        if (response.status === 200) {
          commit('softDelete', communityId)
          commit('decrementCountReportedContent')
          return true
        } else {
          return false
        }
      }).catch(() => {
        return false
      })
  },
  async fetchReportedCommunities ({ commit }) {
    const response = await axios.get(`${config.getRootApi()}/admin/communities/reported`)
    commit('setReportedCommunities', response.data)
  },
  async anonymiseUser(_, userId) {
    return axios.post(`${config.getRootApi()}/admin/users/${userId}/anonymise`)
  }
}

export default {
  state: initialState,
  getters,
  mutations,
  actions
}
